// extracted by mini-css-extract-plugin
export default {"documents":"styles_documents__t7QMe","title":"styles_title__yhatW","documentUpload":"styles_documentUpload__KF44O"};